import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Dropdown from "./Dropdown";
import data from "../content/questions";

const StyledQuestions = styled.div`
  position: relative;
  margin: 45px auto 20px;
  @media all and (max-width: 700px) {
    padding: 0 10px 0;
  }
  h2 {
    margin: 0 auto 20px;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    @media all and (max-width: 700px) {
      font-size: 17px;
    }
  }
  p.requiredcopy {
    margin: -10px auto 25px;
    text-align: center;
    font-size: 11px;
    color: #9b9b9b;
  }
  .questions-area {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
  }
`;

const Questions = ({ lang, copy }) => (
  <StyledQuestions>
    <h2>{copy.options.title}</h2>
    <div className="questions-area">
      {data[lang].map(({ i, q, a, v, dl }) => {
        return (
          <Dropdown
            {...{ lang }}
            key={q}
            identifier={i}
            question={q}
            options={a}
            values={v}
            datalayeraction={dl}
          />
        );
      })}
    </div>
    <p className="requiredcopy">{copy.options.required}</p>
  </StyledQuestions>
);

Questions.defaultProps = {};

Questions.propTypes = {
  copy: PropTypes.objectOf(PropTypes.object).isRequired,
  lang: PropTypes.string.isRequired
};
export default Questions;
